import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { TotalSolidsAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-total-solids-slot',
    templateUrl: './total-solids-slot.component.html',
    styleUrl: './total-solids-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotalSolidsSlotComponent implements SheetSlotComponentBase {

	action!: TotalSolidsAction;
	value!: string | null;

	@Input('action') set updateAction(action: TotalSolidsAction | null) {
		this.action = action as TotalSolidsAction;
		this.value = this.action.totalSolids?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}